module.exports = __webpack_public_path__ + "img/Prime+_logo_channel_b_m.f86ac371.svg";